import { cloneDeep } from "lodash";

import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { SearchPageLadiesResponse, SearchPageQueryParams } from "../models";

export abstract class UserSearchLadiesApi {
  static get = async ({
    pageSize,
    startIndex,
    urlSearchParams,
  }: SearchPageQueryParams) => {
    const response = GbApiRequestService.post("userSearch", {
      startIndex,
      pageSize,
      params: {
        ...mapToFinalQueryValues(urlSearchParams || {}),

        // TODO: RW-116 values will needed for the request
        // /*
        //   appearanceType=LATINA

        //   for top 1000
        //   order=-rating,topLadies=true
        // */
      },
      subType: "LadySearchParams",
    });

    return withSchemaValidation(response, SearchPageLadiesResponse);
  };
}

const mapToFinalQueryValues = (
  params: NonNullable<SearchPageQueryParams["urlSearchParams"]>,
) => {
  const matchingKeys = [
    ["country", "countryIds"],
    ["city", "cityIds"],
    ["eyeColor", "eyeColorIds"],
    ["hairColor", "hairColorIds"],
    ["englishSkill", "englishSkillsIds"],
    ["religion", "religionIds"],
    ["drinking", "drinkingIds"],
    // TODO: RW-116
    // ["", "maritalStatusIds"],
  ] as const;

  const paramsDeepCopy = cloneDeep(params);

  const changedParams = matchingKeys.reduce((acc, [key, newKey]) => {
    if (paramsDeepCopy[key]) {
      const oldValue = paramsDeepCopy[key];

      delete paramsDeepCopy[key];

      return {
        ...acc,
        [newKey]: [oldValue],
      };
    }

    return acc;
  }, {}) as Omit<
    SearchPageQueryParams,
    keyof (typeof matchingKeys)[number][0]
  > & {
    [K in (typeof matchingKeys)[number][1]]: number[];
  };

  const booleanMatch: Record<
    NonNullable<(typeof paramsDeepCopy)["smoking"]>,
    boolean
  > = {
    1: false,
    2: true,
  };

  if (paramsDeepCopy.smoking) {
    (paramsDeepCopy.smoking as unknown as boolean) =
      booleanMatch[paramsDeepCopy.smoking];
  }

  if (paramsDeepCopy.children) {
    (paramsDeepCopy.children as unknown as boolean) =
      booleanMatch[paramsDeepCopy.children];
  }

  return { ...paramsDeepCopy, ...changedParams };
};
